import { HelpMessage } from 'utils/constants'
import CIMSFormItem from 'components/CIMSFormItem'
import { useDisabledOptions } from 'hooks/useDisabledOptions'
import { CIMSFormItemProps } from 'components/CIMSFormItem/types'
import CIMSSelect from 'components/CIMSSelect'
import { useOptions } from 'components/CIMSSelect/hooks/useOptions'
import { useFDCTrackerContext } from '../../../../FDCTrackerContext'
import { IsRequired } from '../types'

const DisciplinesFormItem: React.FC<
  IsRequired & Pick<CIMSFormItemProps, 'disabled'>
> = ({ required = false, disabled }) => {
  const { metadata } = useFDCTrackerContext()
  const options = useOptions({
    items: metadata?.fdcDisciplines,
    label: 'name',
    value: 'id',
    tooltip: 'description',
    sort: 'name',
  })
  const [disabledOptions, { some }] = useDisabledOptions(disabled)
  return (
    <CIMSFormItem
      name="disciplines"
      label="Disciplines"
      requiredMessage={
        required ? 'Please enter at least one discipline' : undefined
      }
      disabled={disabledOptions}
      help={HelpMessage.FieldDesignChanges.FDCTracker.Disciplines}
    >
      <CIMSSelect
        disabled={some}
        options={options}
        multiple
        loading={metadata?.loading}
      />
    </CIMSFormItem>
  )
}

export default DisciplinesFormItem
